import { deleteFeatureAccessAPI, featureAccessCreateAPI, featureAccessGetByIdAPI, featureAccessPagingAPI, featureAccessUpdateAPI } from "../../../api/url"
import { createAPI, deleteAPI, getByBodyAPI, getByIdAPI, updateAPI } from "../../../redux/crudSlice"
import { AppDispatch, store } from "../../../store/store"
import { getLocalStorageItem } from "../../../utils/storageHelper"
import { APICallFunction } from "../role/apiCall"
import { FeaturesAccessKeys } from "./entity"
const { dispatch } = store


export const getFeatureAccessbyId: APICallFunction = async (params) => {
    const { key = FeaturesAccessKeys.get, request = {}, url = featureAccessGetByIdAPI(request?.id) } = params;
    const res = await dispatch(getByIdAPI({ key: key, url: url, params: request}));
    return res?.payload?.value;
}

export const createFeatureAccess: APICallFunction = async (params) => {
    const { key = FeaturesAccessKeys.create, request = {}, url = featureAccessCreateAPI } = params;
    const res = await dispatch(createAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const updateFeatureAccess: APICallFunction = async (params) => {
    const { key = FeaturesAccessKeys.update, request = {}, url = featureAccessUpdateAPI(request.id) } = params;
    const res = await dispatch(updateAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const getFeatureAccessPaging = async ( dispatch: AppDispatch, _request: Object) => {
    await dispatch(getByBodyAPI({
        key: FeaturesAccessKeys.paging,
        url: featureAccessPagingAPI,
        request: { ..._request, ['ApplicationId']: getLocalStorageItem('ApplicationId') },
    }))
}

export const deleteFeatureAccess = async ( dispatch: AppDispatch, _request: Object) => {
    await dispatch(deleteAPI({
        key: FeaturesAccessKeys.delete,
        url: deleteFeatureAccessAPI,
        request: [_request] ,
    }))
}